import React, { useState, useEffect } from "react";
import Loader from "../layout/Loader";
import { toast } from "react-hot-toast";


import {
    useDeleteBlogCommentMutation,
  useLazyGetBlogCommentsQuery,
} from "../../redux/api/blogsApi";
import AdminProfile from "../user/AdminProfile";
import StarRatings from "react-star-ratings";
import { Helmet } from "react-helmet-async";

const BlogComments = () => {
  const [blogId, setBlogId] = useState("");

  const [getBlogReviews, { data, isLoading, error }] =
    useLazyGetBlogCommentsQuery();

  const [
    deleteBlogReview,
    { error: deleteError, isLoading: isDeleteLoading, isSuccess },
  ] = useDeleteBlogCommentMutation();

  useEffect(() => {
    if (error) toast.error(error?.data?.message);
    if (deleteError) toast.error(deleteError?.data?.message);
    if (isSuccess) toast.success("Comment Deleted");
  }, [error, deleteError, isSuccess]);

  const submitHandler = (e) => {
    e.preventDefault();
    if (blogId.trim() === "") return toast.error("Enter a Blog ID");
    getBlogReviews(blogId);
  };

  const deleteReviewHandler = (id) => {
    deleteBlogReview({ blogId, id });
  };

  if (isLoading) return <Loader />;

  return (
    <AdminProfile>
      <Helmet>
        <title>Blog Comments</title>
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>

      {/* Search Form */}
      <div className="w-full max-w-3xl mx-auto my-6 p-6 bg-white rounded-2xl shadow-md">
        <h2 className="text-2xl sm:text-3xl font-playfair text-[#BC3F4A] mb-5 text-center sm:text-left">
          Search Blog Comments
        </h2>

        <form onSubmit={submitHandler} className="space-y-4">
          <div>
            <label
              htmlFor="productId_field"
              className="block mb-2 font-semibold text-gray-700"
            >
              Blog ID
            </label>
            <input
              type="text"
              id="productId_field"
              value={blogId}
              onChange={(e) => setBlogId(e.target.value)}
              placeholder="Enter blog ID..."
              className="w-full p-3 border border-gray-300 rounded-md focus:ring-2 focus:ring-[#BC3F4A] focus:outline-none font-sans text-gray-900"
            />
          </div>

          <button
            type="submit"
            className="w-full sm:w-auto px-6 py-3 bg-[#BC3F4A] hover:bg-[#a3323b] text-white rounded-md font-playfair text-lg transition disabled:opacity-50 disabled:cursor-not-allowed"
            disabled={!blogId}
          >
            SEARCH
          </button>
        </form>
      </div>

      {/* Reviews Feed */}
      {data?.comments?.length > 0 ? (
        <div className="mt-8 w-96 space-y-6 max-w-4xl mx-auto">
          {data.comments.map((review) => (
            <div
              key={review._id}
              className=" bg-white border border-gray-200 rounded-2xl shadow-sm p-4 sm:p-6 hover:shadow-md transition"
            >
              {/* Header: User + Rating */}
              <div className="flex items-center justify-between mb-2">
                <div className="flex items-center space-x-3">
                  <div className="w-10 h-10 rounded-full bg-gray-200 flex items-center justify-center text-gray-600 font-bold">
                    {review.user?.name?.charAt(0) || "U"}
                  </div>
                  <div>
                    <p className="font-semibold text-gray-800">
                      {review.user?.name}
                    </p>
                    <div className="flex items-center justify-center space-x-2 text-sm text-gray-500">
                      <StarRatings
                        rating={review.rating || 0}
                        starEmptyColor="#E5E7EB"
                        starRatedColor="#C19A6B"
                        numberOfStars={5}
                        starDimension="18px"
                        starSpacing="1px"
                        name={`rating-${review._id}`}
                      />
                      <span>({review.rating})</span>
                    </div>
                  </div>
                </div>
                <button
                  onClick={() => deleteReviewHandler(review._id)}
                  disabled={isDeleteLoading}
                  className="px-3 py-1 rounded-full bg-[#BC3F4A] hover:bg-[#a3323b] text-white text-sm transition disabled:opacity-50 disabled:cursor-not-allowed"
                >
                  Delete
                </button>
              </div>

              {/* Comment */}
              <p className="text-gray-700 text-sm sm:text-base mt-2">
                {review.blogcomment}
              </p>

              {/* Footer: Review ID */}
              <p className="text-gray-400 text-xs mt-3">ID: {review._id}</p>
            </div>
          ))}
        </div>
      ) : (
        <p className="mt-10 text-center text-gray-500 font-sans text-sm sm:text-base">
          No Reviews Found
        </p>
      )}
    </AdminProfile>
  );
};

export default BlogComments;